import { Drawer } from "antd";

const ConnectionStepDrawer = ({ open, setOpen }) => (
  <Drawer
    width={490}
    title="連線說明及最佳實務"
    open={open}
    onClose={() => setOpen(false)}
  >
    <div style={{ color: "#666" }}>
      <h4>💾 新 ERP 資料庫連線方式：</h4>
      <ul>
        <li>
          <strong>安全考量：</strong>
          建議客戶為對接專案建立專用資料庫帳號，僅授予必要的唯讀權限
        </li>
        <li>
          <strong>網路環境：</strong>適用於內網環境或透過 VPN/專線連接的情況
        </li>
        <li>
          <strong>效能優勢：</strong>
          直接存取資料庫，查詢效率高，適合大量數據同步
        </li>
        <li>
          <strong>技術要求：</strong>需要了解客戶 ERP 系統的資料庫結構和表格關聯
        </li>
      </ul>

      <h4>🌐 API 連線方式：</h4>
      <ul>
        <li>
          <strong>標準介面：</strong>客戶需提供標準化的 RESTful API 介面
        </li>
        <li>
          <strong>安全性佳：</strong>透過 API 認證機制，不直接暴露資料庫
        </li>
        <li>
          <strong>開發需求：</strong>需要客戶端開發相應的 API 端點和文件
        </li>
        <li>
          <strong>維護便利：</strong>API 版本控制，便於後續功能擴展
        </li>
      </ul>

      <h4>🔧 新 ERP 對接建議流程：</h4>
      <ol>
        <li>
          <strong>需求確認：</strong>與客戶確認 ERP 系統類型、版本和資料結構
        </li>
        <li>
          <strong>權限申請：</strong>協助客戶建立專用同步帳號和必要權限
        </li>
        <li>
          <strong>網路設定：</strong>確認網路連通性和防火牆設定
        </li>
        <li>
          <strong>測試驗證：</strong>先在測試環境進行連線和數據讀取測試
        </li>
        <li>
          <strong>監控機制：</strong>建立連線監控和異常告警機制
        </li>
      </ol>

      <div
        style={{
          marginTop: 16,
          padding: "12px",
          background: "#fff7e6",
          borderRadius: "6px",
          border: "1px solid #ffd591",
        }}
      >
        <h4 style={{ color: "#d46b08", margin: "0 0 8px 0" }}>⚠️ 重要提醒</h4>
        <ul style={{ margin: 0, color: "#ad6800" }}>
          <li>生產環境連線前，請務必在測試環境完成完整測試</li>
          <li>定期更新密碼，避免使用預設或簡單密碼</li>
          <li>建議啟用資料庫連線加密（SSL/TLS）</li>
          <li>記錄連線日誌，便於問題追蹤和安全稽核</li>
        </ul>
      </div>
    </div>
  </Drawer>
);

export default ConnectionStepDrawer;
